import { render, staticRenderFns } from "./AssetConfigHistory.vue?vue&type=template&id=0966e32e"
import script from "./AssetConfigHistory.vue?vue&type=script&lang=js"
export * from "./AssetConfigHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports